import { Typography } from "@mui/material";
import { DefaultCard, PageLayout } from "components";
import DropLetter from "components/layout/dropLetter/DropLetter";
import React from "react";

function PurposePage() {
  return (
    <PageLayout>
      <DefaultCard title="PURPOSE">
        <Typography variant="body1" lineHeight={1.8}>
          <DropLetter letter="B" />
          elieving that there are no limits to God's power, and that the whole
          principle of the Christian life is that we go beyond what is right to
          do that which is well-pleasing to God, our Father, it is the purpose
          of Harmony Hill that all be the praise of His glory.
        </Typography>
        <br />
        <br />
        <br />
        <Typography variant="h6">
          The object of this non-profit corporation shall be to support efforts
          directed to:
        </Typography>
        <Typography variant="body2">
          <ul>
            <li>
              Furtherance and advancement of the Bible principles of
              righteousness as believed and practiced by the Primitive Baptists
            </li>
            <li>
              To encourage and promote the teaching and singing of gospel music
            </li>
            <li>
              To encourage Christian fellowship and all other Christian
              endeavors
            </li>
          </ul>
        </Typography>
      </DefaultCard>
    </PageLayout>
  );
}

export default PurposePage;
